import { useState, useEffect } from "react";
import footerBg from "@/assets/footer-bg.jpg";

interface Sketch {
  partyName: string;
  sketchData: string;
}

export function Sketches() {
  const [sketches, setSketches] = useState<Sketch[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/rsvp/sketches")
      .then((res) => res.json())
      .then((data) => setSketches(data.sketches || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <article className="pt-24 md:pt-32 pb-20 mx-auto px-6 max-w-4xl">
        <h1 className="font-display text-4xl text-foreground text-center mb-12">
          Sketches
        </h1>

        {loading ? (
          <p className="text-center font-body text-muted-foreground">Loading...</p>
        ) : sketches.length === 0 ? (
          <p className="text-center font-body text-muted-foreground">No sketches yet!</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {sketches.map((s) => (
              <div key={s.partyName} className="text-center">
                <img
                  src={s.sketchData}
                  alt={`Sketch by ${s.partyName}`}
                  className="w-full rounded-lg border border-foreground/10 bg-white"
                />
                <p className="mt-3 font-body text-foreground text-sm">
                  {s.partyName}
                </p>
              </div>
            ))}
          </div>
        )}
      </article>
      <img src={footerBg} alt="" className="w-full" />
    </div>
  );
}
